<template>
  <div id="referralView">
    <table class="referralTable">
      <tr>
        <td class="referralTableLeft">
          {{ messages.referralYourCashback[store.langSelect.value] }}
        </td>
        <td>{{ parseInt(store.userInfo.value.Roles.curRefRebate * 100) }} %</td>
      </tr>
      <tr>
        <td class="referralTableLeft">
          {{ messages.referralLink[store.langSelect.value] }}
        </td>
        <td>
          {{ store.ServerUrl }}#/register/{{
            store.userInfo.value.Roles.refOID
          }}
          <el-button size="small" @click="doCopy">
            <el-icon><DocumentCopy /></el-icon>
          </el-button>
        </td>
      </tr>
      <tr>
        <td class="referralTableLeft">
          {{ messages.referralCount[store.langSelect.value] }}
        </td>
        <td>{{ store.userInfo.value.Roles.refCount }}</td>
      </tr>
      <tr>
        <td class="referralTableLeft">
          {{ messages.referralReward[store.langSelect.value] }}
        </td>
        <td>{{ parseInt(store.userInfo.value.Roles.refComission * 100) }} %</td>
      </tr>
      <tr>
        <td class="referralTableLeft">
          {{ messages.referralCashback[store.langSelect.value] }}
        </td>
        <td v-show="cashbackEditView == false">
          {{ parseInt(store.userInfo.value.Roles.refRebate * 100) }} %
          <el-button icon="el-icon-edit" size="small" @click="CashbackEdit">
            <el-icon><Edit /></el-icon>
          </el-button>
        </td>
        <td v-show="cashbackEditView == true">
          <el-input-number
            style="width: 300px; height: 28px"
            v-model="cashback"
            :min="0"
            :max="(store.userInfo.value.Roles.refComission * 100) / 2"
            size="small"
          ></el-input-number>
          <el-button
            style="margin-left: 20px"
            size="small"
            @click="CashbackSave"
          >
            <el-icon><DocumentChecked /></el-icon>
          </el-button>
        </td>
      </tr>
    </table>
    <div>
      <h3></h3>
    </div>
    <div>
      <h3></h3>
    </div>
    <div>
      <h3></h3>
    </div>
    <div>
      <h3></h3>
    </div>
    <div>
      <h3></h3>
    </div>
  </div>
  <div
    class="referralText"
    v-if="store.langSelect.value === 0"
  >
    <ul>
      <li>Пригласи друзей и вместе получайте вознаграждение!</li>
      <li>
        Клиенты открывшие счет АЕ по реферальной ссылке закрепляются за
        Партнером.
      </li>
      <li>
        Партнер получает вознаграждение 40% от комиссии уплаченной по всем
        торговым сделкам клиентов (рефералов).
      </li>
      <li>
        Партнер может установить кешбэк рефералу из собственного вознаграждения,
        но не более его половины.
      </li>
      <li>
        Начисление вознаграждения и кешбэка производится раз в день в 8.55 UTC
        по торговым сделкам совершенным в предыдущий день.
      </li>
      <li>
        В комментариях к транзакциям начисления вознаграждения указаны номера
        счетов рефералов партнера.
      </li>
      <li>
        Перекрестное использование реферальных ссылок запрещено.
      </li>
      <li>Стань Партнером АЕ!</li>
    </ul>
  </div>
  <div
    class="referralText"
    v-if="store.langSelect.value === 1"
  >
    <ul>
      <li>Invite your friends and get rewarded together!</li>
      <li>
        Clients who opened an AE account using a referral link are assigned to
        the Partner.
      </li>
      <li>
        The partner receives a reward of 40% of the commission paid on all
        trading transactions of clients (referrals).
      </li>
      <li>
        A partner can set a cashback for a referral from his own reward, but not
        more than half.
      </li>
      <li>
        Reward and cashback are accrued once a day at 8.55 UTC trading
        transactions made on the previous day.
      </li>
      <li>
        Numbers are indicated in the comments to the commission accrual
        transactions partner referral accounts.
      </li>
      <li>
        Cross-use of referral links is prohibited.
      </li>
      <li>Become an AE Partner!</li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useMyStorage } from "../store/global";
import { copyText } from "vue3-clipboard";
import axios from "axios";
import { Edit, DocumentChecked, DocumentCopy } from "@element-plus/icons-vue";

export default defineComponent({
  name: "ReferralComponent",
  components: { Edit, DocumentChecked, DocumentCopy },
  setup() {
    const store = useMyStorage();
    const messages = {
      referralLink: ["Реферальная ссылка:", "Referral link:"],
      referralCount: ["Количество рефералов:", "Number of referrals:"],
      referralReward: ["Ваше вознаграждение:", "Your reward:"],
      referralCashback: ["Кешбэк рефералу:", "Cashback to referral:"],
      referralYourCashback: ["Ваш кешбэк:", "Your cashback:"],
    };
    const cashbackEditView = ref(false);
    const cashback = ref(0);
    const doCopy = () => {
      copyText(
        store.ServerUrl + "#/register/" + store.userInfo.value.Roles.refOID,
        undefined,
        () => {}
      );
    };
    const CashbackEdit = () => {
      cashback.value = store.userInfo.value.Roles.refRebate * 100;
      cashbackEditView.value = true;
    };
    const CashbackSave = () => {
      store.userInfo.value.Roles.refRebate = parseInt(cashback.value) / 100;

      axios.post(store.ServerUrl + "/users/refrebate/" + cashback.value / 100);
      cashbackEditView.value = false;
    };
    return {
      store,
      messages,
      doCopy,
      CashbackEdit,
      CashbackSave,
      cashbackEditView,
      cashback,
    };
  },
});
</script>

<style lang="scss">
.el-input--small .el-input__inner {
  height: 24px !important;
}
.referralText {
  margin-top: 20px;
  border: 1px #d4d9dd solid;
  padding: 11px 18px;
  border-radius: 3px;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);

  /*  font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;*/
  color: #222;
  margin-bottom: 15px;
  li {
    list-style-image: url(~@/assets/images/arrow-right.svg);
    font-size: 20px;
    margin-bottom: 5px;
  }
  .title {
    //   font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    color: #222;
    margin-bottom: 15px;
  }
}
#referralView {
  border: 1px #d4d9dd solid;
  padding: 11px 18px;
  border-radius: 3px;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  .el-input--mini .el-input__inner {
    height: 28px !important;
  }
}
.referralTable {
  width: 100%;
  margin-bottom: 10px;
  border-spacing: 0px;
  tr {
    height: 45px;
  }
  td {
    padding: 8px 8px 2px 8px;
    border-bottom: 1px solid #e82862;
  }
}
.referralTableLeft {
  text-align: right;
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
}
</style>
